import { Link } from 'react-router';
import '../CSS/Form.css';

export default function Footer({ imageURL, windowWidth }) {
  return (
    <>
      <div id='Footer'>
        <svg
          style={{ display: 'block', overflow: 'visible' }}
          width='100%'
          height={windowWidth > 750 ? '120px' : '60px'}
          viewBox='0 0 1440 120'
          preserveAspectRatio='none'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M0 120V88C0 82.4771 4.47715 78 10 78H323.544C340.8 78 357.675 72.9267 372.07 63.4113L445.93 14.5887C460.325 5.07325 477.2 0 494.456 0H965.134C981.393 0 997.334 4.50444 1011.19 13.0136L1095.81 64.9864C1109.67 73.4955 1125.61 78 1141.87 78H1430C1435.52 78 1440 82.4771 1440 88V120H0Z'
            fill='#3F5896'
            filter='url(#shadow2)'
          />

          <image mask='url(#path-mask2)' href={imageURL} x='0' y='0' width='100%' height='100%' opacity='0.04' preserveAspectRatio='xMidYMid slice' />

          <defs>
            <mask id='path-mask2' x='0' y='0' width='100%' height='100%'>
              <path
                d='M0 120V88C0 82.4771 4.47715 78 10 78H323.544C340.8 78 357.675 72.9267 372.07 63.4113L445.93 14.5887C460.325 5.07325 477.2 0 494.456 0H965.134C981.393 0 997.334 4.50444 1011.19 13.0136L1095.81 64.9864C1109.67 73.4955 1125.61 78 1141.87 78H1430C1435.52 78 1440 82.4771 1440 88V120H0Z'
                fill='white'
              />
            </mask>

            <filter id='shadow2' x='-50%' y='-50%' width='200%' height='200%'>
              <feDropShadow dx='0' dy='-4' stdDeviation='4' floodColor='rgba(0, 0, 0, 0.5)' />
            </filter>
          </defs>
        </svg>

        <div
          style={{
            color: 'white',
            width: '40%',
            fontFamily: 'Jura',
            fontSize: windowWidth > 750 ? '12px' : '8px',
            textAlign: 'center',
            display: 'flex',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            flexDirection: 'column',
          }}>
          <p>© Copyright 2026 All Rights Reserved, SÓKN ENGINEERING INC</p>
        </div>
      </div>
    </>
  );
}
